import moduleTitle from '@/components/moduleTitle.vue'
import pageFooter from '@/components/pageFooter.vue'
import aboutTitle from '@/components/aboutTitle.vue'
import productBanner from '@/components/productBanner.vue'
import productTitle from '@/components/productTitle.vue'
import productCard from '@/components/productCard.vue'
export default {
  install (Vue, options) {
    Vue.component('ModuleTitle', moduleTitle)
    Vue.component('PageFooter', pageFooter)
    Vue.component('AboutTitle', aboutTitle)
    Vue.component('ProductBanner', productBanner)
    Vue.component('ProductTitle', productTitle)
    Vue.component('ProductCard', productCard)
  }
}



// WEBPACK FOOTER //
// ./src/components/index.js